// QA opt-in cookie for the IA restructure experiment (IA nav, Listings entry point and Flexible Properties page).
export const ZRM_IA_RESTRUCTURE_ENABLED = 'ZRM_IA_RESTRUCTURE_ENABLED';

// Split owns population targeting, so there is deliberately no frontend-config rollout flag in this gate.
export const IA_RESTRUCTURE_SPLIT_FEATURE_NAME = 'ZRM-IA_Properties-Listings-Nav-Restructure';

// Internal opt-in cookie for the Portfolio Dashboard page and nav entry; honored in every environment, including prod.
export const ZRM_PORTFOLIO_DASHBOARD_ENABLED = 'ZRM_PORTFOLIO_DASHBOARD_ENABLED';

export const PORTFOLIO_DASHBOARD_SPLIT_FEATURE_NAME = 'zrm_dashboard_page';

// SSR-safe boolean cookie reader. Mirrors zrmw's getCookieAsBoolean: a value of
// 'true' or '1' is truthy. Returns false on the server (no document).
export function getCookieAsBoolean(name: string) {
  if (typeof document === 'undefined') return false;

  const match = document.cookie.split('; ').find((c) => c.startsWith(name + '='));
  if (!match) return false;

  const value = match.slice(name.length + 1);

  return value === 'true' || value === '1';
}
